const Constants = {
  pageWidth: 1300,
  mobileWidth: 768,
}

export default Constants



// WEBPACK FOOTER //
// ./src/helpers/Constants.js